import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { C, field, btnPrimary, softShadow } from "../lib/theme";
import { toast } from "sonner";
import { KeyRound, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md bg-white rounded-3xl p-8 sm:p-10" style={softShadow} data-testid="forgot-card">
        {sent ? (
          <div className="text-center">
            <MailCheck className="w-16 h-16 mx-auto mb-5" style={{ color: C.GREEN }} />
            <h1 className="font-display text-2xl font-extrabold mb-2" style={{ color: C.INK }}>Controlla la tua email</h1>
            <p className="text-sm mb-8" style={{ color: C.MUTED }}>Se esiste un account con questa email, ti abbiamo inviato un link per reimpostare la password. Il link è valido per 1 ora.</p>
            <Link to="/login" className={`${btnPrimary} inline-flex`}>Torna all'accesso</Link>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-3 mb-2">
              <span className="w-11 h-11 rounded-2xl flex items-center justify-center" style={{ background: C.CORAL }}>
                <KeyRound className="w-6 h-6 text-white" />
              </span>
              <span className="font-display text-2xl font-extrabold" style={{ color: C.INK }}>Password dimenticata</span>
            </div>
            <p className="text-sm mb-8" style={{ color: C.MUTED }}>Inserisci la tua email: ti invieremo un link per crearne una nuova.</p>
            <form onSubmit={submit} className="space-y-5">
              <div>
                <label className="block text-sm font-semibold mb-2" style={{ color: "#4a453f" }}>Email</label>
                <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={field} placeholder="tu@ristorante.it" />
              </div>
              <button data-testid="forgot-submit" disabled={loading} className={`${btnPrimary} w-full`}>
                {loading ? "Invio…" : "Invia link di reset"}
              </button>
            </form>
            <p className="text-sm mt-6 text-center" style={{ color: C.MUTED }}>
              Ti sei ricordato la password?{" "}
              <Link to="/login" className="font-bold hover:underline" style={{ color: C.CORAL }}>Accedi</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
